import { useEffect, useState } from 'react';

interface TypedHeadingProps {
  text: string;
  className?: string;
  delay?: number;
  speed?: number;
}

export function TypedHeading({ text, className = '', delay = 120, speed = 45 }: TypedHeadingProps) {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    setTyped('');
    let i = 0;
    const tick = () => {
      i++;
      setTyped(text.slice(0, i));
      if (i < text.length) setTimeout(tick, speed);
    };
    const t = setTimeout(tick, delay);
    return () => clearTimeout(t);
  }, [text, delay, speed]);

  return (
    <h1
      className={`text-3xl md:text-4xl tracking-tight ${className}`}
      style={{ fontWeight: 800, fontFamily: "'SF Pro Display', ui-sans-serif, system-ui, sans-serif" }}
    >
      {typed}
    </h1>
  );
}
